<template>
  <div class="v-tariff-create-form">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">
            <h5 v-if="this.tariffId">Редактировать информацию о тарифе</h5>
            <h5 v-else>Добавить новый тариф</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <div v-if="this.loading">
              <div class="d-flex justify-content-center">
                <div class="spinner-grow m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else class="py-3">
              <form class="form" @submit.prevent="createUpdateTariff" autocomplete="nope">
                <div class="row mx-3">
                  <div class="col-lg-12 pb-3">
                    <multiselect
                      v-model="inputs.dealers"
                      :multiple="true"
                      :options="userList"
                      :close-on-select="false"
                      :clear-on-select="false"
                      placeholder="Выберите дилеров"
                      label="last_name"
                      track-by="id">
                      <template slot="selection"
                                slot-scope="{ dealers, search, isOpen }">
                        <span class="multiselect__single"
                              v-if="inputs.dealers.length &amp;&amp; !isOpen">
                          {{ inputs.dealers.length }} дилер выбран
                        </span>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="row mx-3">
                  <div class="col-lg-4">
                    <div class="form-group" v-bind:class="[ this.tariffId  ? 'filled' : '' ]">
                      <input class="form-control"
                             required id="name" v-model="inputs.name"
                             @focusin="InputFocusIn('name')"
                             @focusout="InputFocusOut('name')"/>
                      <label for="name">Название тарифа</label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group" v-bind:class="[ this.tariffId  ? 'filled' : '' ]">
                      <input class="form-control"
                             required id="internal-name" v-model="inputs.internal_name"
                             @focusin="InputFocusIn('internal-name')"
                             @focusout="InputFocusOut('internal-name')"/>
                      <label for="internal-name">Внутреннее название</label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group" v-bind:class="[ this.tariffId  ? 'filled' : '' ]">
                      <input class="form-control" v-mask="['УТ-########', 'УТ-########']"
                             required id="code_from_1c" v-model="inputs.code_from_1c"
                             @focusin="InputFocusIn('code_from_1c')"
                             @focusout="InputFocusOut('code_from_1c')"/>
                      <label for="code_from_1c">ID товара из 1С</label>
                    </div>
                  </div>
                </div>

                <div class="row mx-3">
                  <div class="col-lg-4">
                    <div class="form-group" v-bind:class="[ this.tariffId  ? 'filled' : '' ]">
                      <input class="form-control"
                             required id="price" v-model="inputs.price"
                             @focusin="InputFocusIn('price')"
                             @focusout="InputFocusOut('price')"/>
                      <label for="price">Цена оператора</label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group" v-bind:class="[ this.tariffId  ? 'filled' : '' ]">
                      <input class="form-control"
                             required id="dealer-fee" v-model="inputs.dealer_fee"
                             @focusin="InputFocusIn('dealer-fee')"
                             @focusout="InputFocusOut('dealer-fee')"/>
                      <label for="dealer-fee">Комиссия дилера</label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group" v-bind:class="[ this.tariffId  ? 'filled' : '' ]">
                      <input class="form-control"
                             required id="service-fee" v-model="inputs.service_fee"
                             @focusin="InputFocusIn('service-fee')"
                             @focusout="InputFocusOut('service-fee')"/>
                      <label for="service-fee">Комиссия сервиса</label>
                    </div>
                  </div>
                </div>

                <div class="row mx-3 pt-3 text-center">
                  <div class="col-6">
                    <div class="">
                      <input
                        type="checkbox" class="form-check-input"
                        v-model="inputs.is_active">
                      <label class="pl-3">
                        Тариф активен
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="">
                      <input
                        type="checkbox" class="form-check-input"
                        v-model="inputs.is_variable_payment_date">
                      <label class="pl-3">
                        Изменяемая дата платежа
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row mx-3 pt-3">
                  <div class="col-12">
                     <button v-if="this.tariffId" type="submit" class="btn btn-primary">
                       Обновить информацию
                     </button>
                     <button v-else type="submit" class="btn btn-primary">
                       Добавить тариф
                     </button>
                  </div>
                </div>
              </form>
            </div>
          </slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import tariffAPI from '../../api/tariff';

export default {
  name: 'v-tariff-create-form',
  components: { Multiselect },
  props: ['tariffId'],
  data() {
    return {
      inputs: {
        tariff_group: '',
        name: '',
        code_from_1c: '',
        internal_name: '',
        price: '',
        dealers: '',
        dealer_fee: '',
        service_fee: '',
        is_variable_payment_date: false,
        is_active: false,
      },
      loading: true,
      formatDealers: [],
    };
  },
  computed: {
    ...mapState('user', ['userList', 'error']),
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    ...mapActions('tariff', ['updateTariff', 'createTariff']),
    close() {
      this.$emit('close');
    },
    refactoringDealers() {
      let i;
      for (i = 0; i < this.inputs.dealers.length; i += 1) {
        this.formatDealers.push(this.inputs.dealers[i].id);
      }
      this.inputs.dealers = this.formatDealers;
    },
    createUpdateTariff() {
      this.refactoringDealers();
      if (this.tariffId) {
        const newData = { tariffId: this.tariffId, data: this.inputs };
        this.updateTariff(newData)
          .then(() => {
            if (!this.error) {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'success',
                text: 'Тариф успешно обновлен!',
              });
            } else {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'error',
                text: 'Произошла ошибка!',
              });
            }
          })
          .finally(() => { this.close(); });
      } else {
        this.createTariff(this.inputs)
          .then(() => {
            if (!this.error) {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'success',
                text: 'Новый тариф успешно добавлен!',
              });
            } else {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'error',
                text: 'Произошла ошибка!',
              });
            }
          })
          .finally(() => { this.close(); });
      }
    },
  },
  mounted() {
    if (this.tariffId) {
      tariffAPI.getTariff(this.tariffId)
        .then((response) => { this.inputs = response.data; });
    }
    this.getUserList('?role=dealer&get_all=true')
      .then(() => { this.loading = false; });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
